/* eslint-disable react/jsx-sort-props */
/* eslint-disable indent */
/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React from "react";
import { Tooltip } from "react-tippy";
import prettyPrint from "./CorrespondingCrossComponent/prettyPrint";
import t from "../../Common/utils/translation/translator";

const getInertiaRatio = (input, output) => {
  // Ratio < 10 (Warning level 1): Good --> Green color coding
  // 10 (Warning level 1) < Ratio < 50 (Warning level 2): ok --> Orange color coding ("ok, probably works for low dynamic applications")
  // 50 (Warning level 2) < Ratio: Not good --> Red color coding ("not good, but could work for slow and steady motion.")
  const inertiaRatio = Math.round((input / output) * 100) / 100;
  const warningLevelColor =
    input === null || input === undefined || input === ""
      ? ""
      : inertiaRatio < 10
      ? "text-warningLevelGreen"
      : inertiaRatio < 15
      ? "text-warningLevelYellow"
      : "text-warningLevelOrange";

  const tooltipText =
    input === null || input === undefined || input === ""
      ? t("msizer.ui.tooltip_inertia_ratio_empty")
      : inertiaRatio < 10
      ? null
      : inertiaRatio < 15
      ? t("msizer.ui.tooltip_inertia_ratio_medium")
      : t("msizer.ui.tooltip_inertia_ratio_high");

  return (
    <Tooltip title={tooltipText} position="bottom" duration={200} arrow size="small" theme="light">
      <span className={warningLevelColor}>
        {input === null || input === undefined || input === ""
          ? prettyPrint("inertiaRatio", "N/A")
          : prettyPrint("inertiaRatio", inertiaRatio)}
      </span>
    </Tooltip>
  );
};

export default getInertiaRatio;
